<tix-card
  class="p-8 bg-white md:rounded-2xl sm:rounded-none shadow-xl text-center max-w-4xl mx-auto"
>
  <h1 class="text-3xl font-bold mb-10">Request to Delete Account</h1>

  <p class="mb-3 mx-auto">
    To delete your account on the "AsylumTix Boxoffice Scanner" app or the
    asylumtix.com website, send us an email at:
    <a href="mailto:support@asylumtix.com">{{ 'support@asylumtix.com' }}</a> to
    request an account deletion, you will receive an email to verify your
    request. Once the request is verified we will take care of deleting your
    account and its associated data (First & last name, address, phone number
    and email address) in 2-5 business days after the request verification.
  </p>
  <a href="mailto:support@asylumtix.com" tix-button>Click here to contact us</a>
</tix-card>
